import { render, staticRenderFns } from "./EditCompanyGoalsBadgesView.vue?vue&type=template&id=ee518836"
import script from "./EditCompanyGoalsBadgesView.vue?vue&type=script&lang=js"
export * from "./EditCompanyGoalsBadgesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports